import React from 'react';
import { connect } from 'react-redux';

import { toggleSignupWizard } from '../../../../../Redux/Actions/SignupWizardActions';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem} from 'reactstrap';

import './StandardWizardNav.scss';

class StandardWizardNav extends React.Component {
    constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.state = {
          isOpen: false
        };
      }
      toggle() {
        this.setState({
          isOpen: !this.state.isOpen,
          condition: !this.state.condition
        });
      }

    render() {
        return (
            <div className="status-nav">
                <Navbar light expand="md">
                    <NavbarBrand href="/home">                        
                        <div className="closeContainer">
                            <img src="/images/cancel-white.png" alt="Cancel Button" />
                            <div>
                                <p className="header">Cancel</p>
                            </div>
                        </div>
                    </NavbarBrand>

                    <NavbarToggler onClick={this.toggle} />
                    {/* <div onClick={this.toggle} className= { this.state.condition ? "show-button" : "hide-button" }>
                        <img src="/images/cancel.png" alt="Cancel Button" />
                    </div> */}
                    
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav navbar>
                            <NavItem>
                                <div className="progressContainer">
                                    <img src="/images/wizardCheckmark-white.png" alt="checked" />
                                    <div className="activeWizardNav progressContainer-info">
                                        <p className="header">Step 1: <span className="header-info">Account Info</span></p>
                                        <p className="subheader">Input your account information</p>
                                    </div>
                                </div>
                            </NavItem>
                            <NavItem>
                                <div className="progressContainer">
                                    {this.props.signupWizard.signupStep > 1 ? <img src="/images/wizardCheckmark-white.png" alt="checked" /> : <img src="/images/wizardCircle-white.png" alt="Not Checked" />}
                                    <div className={this.props.signupWizard.signupStep > 1 ? "activeWizardNav" : "progressContainer-info"}>
                                        <p className="header">Step 2: <span className="header-info">Interests</span></p>
                                        <p className="subheader">Set your notification interests</p>
                                    </div>
                                </div> 
                            </NavItem>
                            <NavItem>
                                <div className="progressContainer">
                                    {this.props.signupWizard.signupStep > 2 ? <img src="/images/wizardCheckmark-white.png" alt="checked" /> : <img src="/images/wizardCircle-white.png" alt="Not Checked" />}
                                    <div className={this.props.signupWizard.signupStep > 2 ? "activeWizardNav" : "progressContainer-info"}>
                                        <p className="header">Step 3: <span className="header-info">Add-ons</span></p>
                                        <p className="subheader">Buy Add-ons</p>
                                    </div>
                                </div>
                            </NavItem>
                            <NavItem>
                                <div className="progressContainer">
                                    {this.props.signupWizard.signupStep > 3 ? <img src="/images/wizardCheckmark-white.png" alt="checked" /> : <img src="/images/wizardCircle-white.png" alt="Not Checked" />}
                                    <div className={this.props.signupWizard.signupStep > 3 ? "activeWizardNav" : "progressContainer-info"}>
                                        <p className="header">Step 4: <span className="header-info">Confirm</span></p>
                                        <p className="subheader">Confirm your membership</p>
                                    </div>
                                </div>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
            // <div>
            //     <Button color="primary" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Toggle</Button>
            //     <Collapse isOpen={this.state.collapse}>
            //         <div className="wizardNav">
            //             <div className="closeContainer">
            //                 <a href="/home">
            //                     <img src="/images/cancel.png" />
            //                     <div className="activeWizardNav">
            //                         <p className="header">Cancel</p>
            //                     </div>
            //                 </a>
            //             </div>
            //             <div className="progressContainer">
            //                 <img src="/images/wizardCheckmark.png" alt="checked" />
            //                 <div className="activeWizardNav">
            //                     <p className="header">Step 1: Account Info</p>
            //                 </div>
            //             </div>
            //             <div className="progressContainer">
            //                 {this.props.signupWizard.signupStep > 1 ? <img src="/images/wizardCheckmark.png" alt="checked" /> : <img src="/images/wizardCircle.png" alt="Not Checked" />}
            //                 <div className={this.props.signupWizard.signupStep > 1 ? "activeWizardNav" : null}>
            //                     <p className="header">Step 2: Billing Info</p>
            //                 </div>
            //             </div>
            //             <div className="progressContainer">
            //                 {this.props.signupWizard.signupStep > 2 ? <img src="/images/wizardCheckmark.png" alt="checked" /> : <img src="/images/wizardCircle.png" alt="Not Checked" />}
            //                 <div className={this.props.signupWizard.signupStep > 2 ? "activeWizardNav" : null}>
            //                     <p className="header">Step: 3 Add-ons</p>
            //                 </div>
            //             </div>
            //             <div className="progressContainer">
            //                 {this.props.signupWizard.signupStep > 3 ? <img src="/images/wizardCheckmark.png" alt="checked" /> : <img src="/images/wizardCircle.png" alt="Not Checked" />}
            //                 <div className={this.props.signupWizard.signupStep > 3 ? "activeWizardNav" : null}>
            //                     <p className="header">Step 4: Confirm</p>
            //                 </div>
            //             </div>
            //         </div>
            //     </Collapse>
            // </div>
        );
    }
}

function mapStateToProps(state) {
    return { signupWizard: state.signupWizard }
}

export default connect(mapStateToProps, { toggleSignupWizard })(StandardWizardNav);